module.exports = "mutation ($data: ResidentialTemplateCreate!) {\n  ResidentialTemplateCreate(data: $data) {\n    id\n  }\n}\n"